import * as React from 'react';

function SvgFb(props) {
    return (
        <svg width={17} height={33} viewBox="0 0 17 33" {...props}>
            <path
                d="M4.165 11.145H0v5.463h4.165v16.388h6.941V16.608h5.056l.497-5.463h-5.553V8.868c0-1.304.267-1.82 1.548-1.82h4.005V.219h-5.286C6.38.22 4.165 2.381 4.165 6.522v4.623z"
                fillRule="evenodd"
            />
        </svg>
    );
}

export default SvgFb;
